module.exports = __webpack_public_path__ + "img/area-comum-11.42f7a4cd.png";